import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  onSnapshot,
  query,
  orderBy,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase/config";

const ORDERS = collection(db, "orders");

// ── Customer submits booking → saves to Firebase ──────────────
export async function createOrder(formData) {
  try {
    const orderId = "ORD-" + Date.now().toString().slice(-6);
    const ref = await addDoc(ORDERS, {
      ...formData,
      orderId,
      status:    "Pending",
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
    return { success: true, docId: ref.id, orderId };
  } catch (err) {
    return { success: false, error: err.message };
  }
}

// ── Admin dashboard listens to ALL orders live ────────────────
// The moment a customer books, admin sees it instantly
// No page refresh needed
export function listenToOrders(callback) {
  const q = query(ORDERS, orderBy("createdAt", "desc"));
  return onSnapshot(q, (snap) => {
    const orders = snap.docs.map((d) => ({
      id: d.id,
      ...d.data(),
    }));
    callback(orders);
  });
}

// ── Admin updates order status ────────────────────────────────
// e.g. Pending → In Progress → Completed → Picked Up
export async function updateOrderStatus(docId, newStatus) {
  try {
    await updateDoc(doc(db, "orders", docId), {
      status:    newStatus,
      updatedAt: serverTimestamp(),
    });
    return { success: true };
  } catch (err) {
    return { success: false, error: err.message };
  }
}

// ── Admin deletes an order ────────────────────────────────────
export async function deleteOrder(docId) {
  try {
    await deleteDoc(doc(db, "orders", docId));
    return { success: true };
  } catch (err) {
    return { success: false, error: err.message };
  }
}